import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API_URL;

export default function SwapRequestModal({ show, onClose, slotId, onUpdated = () => {} }) {
    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [availableSlots, setAvailableSlots] = useState([]);
    const [targetSlotIds, setTargetSlotIds] = useState([]);
    const [canSwap, setCanSwap] = useState(false);

    // 0) Modal açılışında ya da kapanışında state'leri sıfırla
    useEffect(() => {
        if (show) {
            setSelectedUserId(null);
            setAvailableSlots([]);
            setTargetSlotIds([]);
            setCanSwap(false);
        }
    }, [show]);

    // 1) Modal açıldığında uygun kişileri getir
    useEffect(() => {
        if (show && slotId) {
            axios.get(`${API_URL}/Custom/GetEligibleSwapUsers`, { params: { slotId } })
                .then(({ data }) => setUsers(data))
                .catch(console.error);
        }
    }, [show, slotId]);

    // 2) Seçilen kullanıcıya ait takas için uygun slotları getir
    useEffect(() => {
        if (selectedUserId) {
            setTargetSlotIds([]);
            axios.get(`${API_URL}/Custom/GetEligibleSwapSlots`, {
                params: { slotId, targetUserId: selectedUserId }
            })
                .then(({ data }) => setAvailableSlots(data))
                .catch(console.error);
        } else {
            setAvailableSlots([]);
            setTargetSlotIds([]);
        }
    }, [selectedUserId, slotId]);

    // 3) Tüm gerekli alanlar dolduğunda swap butonunu aktif et (dosya zorunlu)
    useEffect(() => {
        setCanSwap(
            selectedUserId &&
            targetSlotIds.length > 0
        );
    }, [selectedUserId, targetSlotIds]);

    // Checkbox değişim fonksiyonu
    const handleCheckboxChange = (slotIdValue) => {
        setTargetSlotIds(prev =>
            prev.includes(slotIdValue)
                ? prev.filter(id => id !== slotIdValue)
                : [...prev, slotIdValue]
        );
    };

    const handleRequest = () => {
        const formData = new FormData();
        formData.append('slotId', slotId);
        formData.append('targetUserId', selectedUserId);
        targetSlotIds.forEach(id => formData.append('targetSlotIds', id));

        axios.post(`${API_URL}/Custom/RequestSwap`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then(() => {
                Swal.fire({
                    title: 'Talebiniz Gönderildi',
                    text: `Değişim talebiniz karşı kullanıcıya e-posta ile iletilmiştir. İlgili kullanıcı onayladıktan sonra yönetim onayı otomatik verilecek ve sonuç yönetime e-posta ile bildirilecektir. Talebin acil olması durumunda kullanıcıyı ayrıca bilgilendirmeniz süreci hızlandırabilir.

Talep durumunuzu anasayfadan takip edebilirsiniz. Karşı kullanıcı onaylamadan değişim işlemi kesinleşmiş olmayacaktır.`,
                    icon: 'success',
                    confirmButtonText: 'Tamam'
                }).then(() => {
                    onClose();
                    onUpdated();
                });
            })
            .catch(err => {
                console.error(err);
                Swal.fire({
                    title: 'Hata',
                    text: 'Talebiniz gönderilirken bir sorun oluştu. Lütfen tekrar deneyin.',
                    icon: 'error',
                    confirmButtonText: 'Kapat'
                });
            });
    };

    if (!show) return null;

    return (
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{ backgroundColor: 'rgba(255,255,255,0.75)', zIndex: 2000 }}
        >
            <div className="modal-content" style={{ maxWidth: '90%', width: '400px' }}>
                <div className="modal-header">
                    <h5 className="modal-title">Görev Değişim Talebi</h5>
                    <button type="button" className="btn-close" onClick={onClose}></button>
                </div>
                <div className="modal-body">
                    {/* Kullanıcı Seçimi */}
                    <div className="mb-3">
                        <label className="form-label">Kişi Seç:</label>
                        <select
                            className="form-select"
                            value={selectedUserId || ''}
                            onChange={e => setSelectedUserId(e.target.value)}
                        >
                            <option value="">-- Seçiniz --</option>
                            {users.map(u => (
                                <option key={u.id} value={u.id}>
                                    {u.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Checkbox list for slots */}
                    {selectedUserId && (
                        <div className="mb-3">
                            <label className="form-label">
                                Görev alabileceğiniz gün / saatleri seçiniz. Onaylanması durumunda bir tanesi ile değişim yapılacaktır.
                            </label>
                            <div
                                style={{
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    paddingRight: '4px'
                                }}
                            >
                                {availableSlots.map(s => (
                                    <div key={s.id} className="form-check mb-1">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`slot-${s.id}`}
                                            checked={targetSlotIds.includes(s.id.toString())}
                                            onChange={() => handleCheckboxChange(s.id.toString())}
                                        />
                                        <label className="form-check-label" htmlFor={`slot-${s.id}`}>
                                            {new Date(s.date).toLocaleDateString('tr-TR')} {' '}
                                            {s.startTime.substring(0, 5)} – {s.endTime.substring(0, 5)}
                                        </label>
                                    </div>
                                    ))}
                                </div>
                            </div>
                        )}
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={onClose}>
                        Kapat
                    </button>
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleRequest}
                        disabled={!canSwap}
                    >
                        Değişim Talebi Gönder
                    </button>
                </div>
            </div>
        </div>
    );
}
